import { ElLoading } from 'element-plus'

/* 全局请求 loading(服务方式调用) */
let loadingInstance: ReturnType<typeof ElLoading.service>
let loadingTimeOut: NodeJS.Timeout | undefined = undefined
const startLoading = () => {
  //为防止高网速的请求让网页频繁黑屏，loading延迟500ms再出现
  loadingTimeOut = setTimeout(() => {
    loadingInstance = ElLoading.service({
      fullscreen: true,
      body: true,
      // lock: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.2)'
    })
  }, 200)
}
const endLoading = () => {
  clearTimeout(loadingTimeOut)
  if (loadingInstance) loadingInstance.close()
}

// 那么 showFullScreenLoading() tryHideFullScreenLoading() 要做的事就是将同一时刻的请求合并。
// 声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
// 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
/**
 * 展示全屏加载。通过次数进行控制
 */
export const showFullScreenLoading = () => {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

/**
 * 尝试关闭全屏加载。只有api计数归零时才能真正关闭全屏加载，
 * @returns
 */
export const tryHideFullScreenLoading = () => {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}
